import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslocoModule } from '@ngneat/transloco';
import { CountryISO, NgxIntlTelInputModule } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  standalone: false,
})
export class UserDetailsComponent implements OnInit {

  selectedCountry: CountryISO = CountryISO.Kuwait;
  onlyCountries: CountryISO[] = [CountryISO.Kuwait, CountryISO.India, CountryISO.UnitedStates];
  profileForm!: FormGroup;
  @Input() id!: string;
  @Input() name!: string;
  @Input() showError!: boolean;
  @Input() showSpinner!: boolean;
  @Input() isOnlinePay!: boolean;
  @Input() forgotpass!: boolean;
  @Output() submit: EventEmitter<any> = new EventEmitter();

  constructor(private fb: FormBuilder) { }
  ngOnInit(): void {
    this.profileForm = this.fb.group({
      mobileNumber: [undefined, [Validators.required]]
    });
  }

  verify() {
    if (this.profileForm.valid) {
      this.submit.emit(Object.assign({}, this.profileForm.value, 
        { mobileNumber: this.profileForm.value.mobileNumber.internationalNumber.replace(/\s/g, "") }));
    } else {
    }
  }

  validate(control: string) {
    return this.profileForm.get(control);
  }
}
